import { SolidMerchantDataRequest, SolidMerchantDataResponse, SolidPostInitRequest } from '../types/payment';

import Base from './Base';

class PaymentApi extends Base {
    getSolidMerchantData = async <Data = SolidMerchantDataRequest, Response = SolidMerchantDataResponse>(
        payload: Data
    ): Promise<Partial<Response>> => {
        return await this.apiClient.public.post<typeof payload, Response>('payments/merchant-data', payload);
    };

    solidPostInit = async <Data = SolidPostInitRequest>(payload: Data): Promise<void> => {
        await this.apiClient.public.post<typeof payload, Response>('payments/post-init', payload);
    };
}

export default PaymentApi;
